import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const PublicRoute = ({ children, redirectTo = '/dashboard' }: PublicRouteProps) => {
  const isAuthenticated = authService.isAuthenticated();
  
  if (isAuthenticated) {
    // Redirect to dashboard if already authenticated
    return <Navigate to={redirectTo} replace />;
  }
  
  return <>{children}</>;
};
